import { propertyDetailsTabs } from '@/data/data-selectors';
import { useSelector } from 'react-redux';

export function useActivityFeed() {
  const tabs = useSelector(propertyDetailsTabs);

  const isEnabled = tabs?.activity?.enabled;
  return { isEnabled };
}
